import axios from 'axios'

export const getAllAffiliates = (params) => {
  return axios.get('/affiliates', {params: params})
}

export const getAffiliate = (id, params) => {
  return axios.get('/affiliates/' + id, {params: params})
}

export const createAffiliate = (data) => {
  return axios.post('/affiliates', data)
}

export const editAffiliate = (id, data) => {
  return axios.put('/affiliates/' + id, data)
}

export const deleteAffiliate = (id) => {
  return axios.delete('/affiliates/' + id)
}

export const confirmRequestPayment = (id) => {
  return axios.get('/request-payments/' + id + '/payment')
}



// WEBPACK FOOTER //
// ./src/api/affiliates.js